/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetMiscTrackingDetect } from "../../funcs/miscGetMiscTrackingDetect.js";
import { GetMiscTrackingDetectRequest$zodSchema } from "../../models/getmisctrackingdetectop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetMiscTrackingDetectRequest$zodSchema,
};

export const tool$miscGetMiscTrackingDetect: ToolDefinition<typeof args> = {
  name: "misc-get-misc-tracking-detect",
  description: `识别快递公司

不确定手里的快递单号属于哪家快递公司？这个接口专门做识别，不查物流。

> [!VIP]
> 本API目前处于**限时免费**阶段，我们鼓励开发者集成和测试。未来，它将转为付费API，为用户提供更稳定和强大的服务。

## 功能概述
输入快递单号，系统会根据单号规则快速识别出最可能的快递公司。如果存在多个可能的匹配结果，还会在 \`alternatives\` 字段中返回备选项，供你参考选择。

## 使用须知
- **识别速度快**：只做规则匹配，不查询物流信息，响应速度通常在100ms内
- **准确率高**：基于各快递公司的单号规则进行智能识别，准确率超过95%
- **备选方案**：当单号规则可能匹配多家快递公司时，会提供所有可能的选项`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscGetMiscTrackingDetect(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
